var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePage } from '@inertiajs/react';
export default function JetValidationErrors(_a) {
    var className = _a.className;
    var props = usePage().props;
    var errors = props.errors;
    var hasErrors = Object.keys(errors).length > 0;
    if (!hasErrors) {
        return null;
    }
    //console.log('JetValidationErrors' ,errors)
    return (_jsxs("div", __assign({ className: className }, { children: [_jsx("div", __assign({ className: "font-medium text-red-600" }, { children: "Whoops! Something went wrong." })), _jsx("ul", __assign({ className: "mt-3 list-disc list-inside text-sm text-red-600" }, { children: Object.keys(errors).map(function (key) { return (typeof errors[key] == "object" ? Object.keys(errors[key]).map(function (key2) { return _jsx("li", { children: errors[key][key2] }, key2); }) : _jsx("li", { children: errors[key] }, key)); }) }))] })));
}
